const data = [
    {
       'nombre':'Cafayate',
       'zona':'no',
       'imagen':'cafayate.jpg',
       'situacion':'Localidad de los valles Calchaquíes de la provincia de Salta.',
       'servicio':'Visita a las formaciones de roca caliza y viñedos',
       'precio':90
    },
    {
       'nombre':'Parque Nacional Los Cardones',
       'zona':'no',
       'imagen':'cachi.webp',
       'situacion':'Cerca de la localidad de Payogasta (Selva de las Yungas).',
       'servicio':'Caminata por la desértica belleza del Parque Nacional',
       'precio':85
    },
    {
       'nombre':'Viaducto La Polvorilla',
       'zona':'no',
       'imagen':'polvorilla.jpg',
       'situacion':'Recorrido en el Tren a las Nubes (desde Salta).',
       'servicio':"Recorrido por los viaductos del Tren a las Nubes del ramal C-14",
       'precio':124
    },
    {
       'nombre':'Iruya',
       'zona':'no',
       'imagen':'iruya.jpg',
       'situacion':'Provincia de Salta (Sierra de Santa Victoria).',
       'servicio':"Recorrido por la zona (Mirador, Río, iglesias..)",
       'precio':78
    },
    {
       'nombre':'Buenos Aires',
       'zona':'no',
       'imagen':'buenosaires.jpg',
       'situacion':'Ciudad autónoma y capital federal de Argentina.',
       'servicio':"Visita los barrios y plazas más representativos",
       'precio':195
    },
    {
       'nombre':'Cataratas del Iguazú',
       'zona':'no',
       'imagen':'iguazu.jpg',
       'situacion':'Entre las provincias de Misiones y Paraná.',
       'servicio':"Recorrido por los diferentes senderos (Macuco..)",
       'precio':172
    },
    {
       'nombre':'San Nicolás de los Arroyos',
       'zona':'no',
       'imagen':'san_nicolas_de_los_arrayos.jpg',
       'situacion':'Extremo norte de la Provincia de Buenos Aires.',
       'servicio':"Escapada a Santuario, Teatro, Parque y Catedral",
       'precio':82
    },
    {
       'nombre':'Rosario',
       'zona':'no',
       'imagen':'rosario.webp',
       'situacion':'Sureste de la Provincia de Santa Fé del Departamento de Rosario.',
       'servicio':"Recorrido por el Monumento, museos y parques",
       'precio':79
    },
    {
       'nombre':'Córdoba',
       'zona':'cp',
       'imagen':'cosquin.webp',
       'situacion':'Capital de la Provincia de Córdoba (a orillas del río Suquía).',
       'servicio':"Visita a Altas Cumbres, Capuchinos, 100 curvas y Museos",
       'precio':85
    },
    {
       'nombre':'Mendoza',
       'zona':'cp',
       'imagen':'mendoza.webp',
       'situacion':'Capital de la Provincia, al este de la Cordillera de los Andes.',
       'servicio':"Visita al Aconcagua, viñedos, bodegas y parques",
       'precio':71
    },
    {
       'nombre':'La cumbrecita',
       'zona':'cp',
       'imagen':'cumbrecita.webp',
       'situacion':'Valle de Calamuchita (Sierras Grandes, Provincia de Córdoba).',
       'servicio':"Visita a las cascadas, peñón y río subterráneo",
       'precio':83
    },
    {
       'nombre':'Mar Chiquita Lake',
       'zona':'cp',
       'imagen':'mar_chiquita_lake.jpg',
       'situacion':'Noroeste de la Provincia de Córdoba (Santiago del Estero).',
       'servicio':"Paseo en bote por la costonera, playa y el Mistolar",
       'precio':182
    },
    {
       'nombre':'Puerto Madryn',
       'zona':'cp',
       'imagen':'madryn.webp',
       'situacion':'Noroeste de la Provincia de Chubut (Dpto. de Biedma).',
       'servicio':"Ver las ballenas y lobos marinos en Punta Loma",
       'precio':197
    },
    {
       'nombre':'Parque Nal. Monte León',
       'zona':'cp',
       'imagen':'monte_leon.webp',
       'situacion':'Litoral marítimo de la Provincia de Santa Cruz (Patagonia).',
       'servicio':"Recorrido por los senderos y lagos del Parque",
       'precio':69
    },
    {
       'nombre':'Rada Tilly',
       'zona':'cp',
       'imagen':'rada_tilly.jpg',
       'situacion':'Provincia del Chubut (a 15 km. al sur de Comodoro Rivadavia).',
       'servicio':"Visita a la Reserva Natural y Museo Regional",
       'precio':112
    },
    {
       'nombre':'Puerto Deseado',
       'zona':'cp',
       'imagen':'puerto_deseado.jpg',
       'situacion':'Provincia de Santa Cruz (al norte de la Ría Deseado).',
       'servicio':"Visita Isla Pinguinos, Reserva Natural y Gruta",
       'precio':163
    },
 ]
 
 export default data